<script lang="ts" setup>
  import { getImage } from '@/shared/lib/media'

  import { useProfile, UserAvatar } from '@/entities/profile'

  const { fullName, profile } = storeToRefs(useProfile())
  const userAvatar = computed(() => getImage({ id: profile.value?.attachments?.[0], quality: 70 }))
</script>

<template>
  <div class="user-info__container">
    <UserAvatar
      :src="userAvatar"
      :size="50"
    />
    <div class="user-info__summary">
      <div class="user-info__name">{{ fullName }}</div>
      <div
        v-if="profile?.position"
        class="user-info__position"
      >
        {{ profile?.position }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .user-info {
    &__container {
      @include flex-container(row, flex-start, center);
      gap: 11px;
    }
    &__summary {
      @include flex-container(column, flex-start, flex-start);
      gap: 4px;
    }
    &__name {
      @include font-montserrat-600(14px, 17px, var(--text-primary));
    }
    &__position {
      @include font-montserrat-400(12px, 14px, var(--text-secondary));
    }
  }
</style>
